import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Modalable, ResponseStatus } from '../../../../../models/modalable';
import { ModalService } from '../../../../../services/modal.service';
import { QuickLink, QuickLinkType } from '../../../../../models/quick-link';
import { ApplicationStateService } from '../../../../../services/application-state.service';
import { QuickLinkService } from '../../../../../services/quick-link.service';
import { HomeworkService } from '../../../../../services/homework.service';
import { PageService } from '../../../../../services/page.service';
import { RouteService } from '../../../../../services/route.service';
import { environment } from '../../../../../../environments/environment';
import { UserDataService } from '../../../../../services/user-data.service';
import { ModalableYedo } from '../../../../../models/modalable-yedo';
import { ModalableAccessCode } from '../../../../../models/modalable-access-code';
import { ModalComponent } from '../../../../../models/modal-component';
import { DisabledFeatureModalable } from '../../../../../models/disabled-feature-modalable';
import { CookieService } from 'ngx-cookie-service';
import { AssetPipe } from '../../../../../pipes/asset.pipe';
import {
    Digi4schoolInformationComponent
} from './feature-disabled-contents/digi4school-information/digi4school-information.component';
import { FeatureDisabledPlusComponent } from './feature-disabled-plus/feature-disabled-plus.component';
import { BookAccessCodeFormComponent } from '../../../../utils/book-access-code-form/book-access-code-form.component';
import { FeatureDisabledHeaderComponent } from './feature-disabled-header/feature-disabled-header.component';
import { RoutePipe } from '../../../../../pipes/route.pipe';

// eslint-disable complexity
@Component({
    selector: 'app-feature-disabled',
    templateUrl: './feature-disabled.component.html',
    styleUrls: ['./feature-disabled.component.scss'],
    standalone: true,
    imports: [
        AssetPipe,
        Digi4schoolInformationComponent,
        FeatureDisabledPlusComponent,
        BookAccessCodeFormComponent,
        FeatureDisabledHeaderComponent,
        RoutePipe
    ]
})
export class FeatureDisabledComponent extends ModalComponent implements OnInit, OnChanges {

    @Input() modalable: Modalable;

    responseStatus = ResponseStatus;

    type: QuickLinkType | string = 'type';

    isLoggedIn: boolean;
    hasBookAccessCode: boolean;
    hasBookAccessCodePlus: boolean;

    physicalProductLink: string;
    storeLink: string;
    coverImg: string;
    requiresPremiumPlus = false;
    requiresPlus = false;
    hasBookAccessCodeNormal = false;

    dismissText: string;
    contactURL: string;

    protected readonly ModalService = ModalService;

    constructor(
        public applicationStateService: ApplicationStateService,
        private modalService: ModalService,
        public quicklinkService: QuickLinkService,
        private pageService: PageService,
        private homeworkService: HomeworkService,
        private routeService: RouteService,
        public userDataService: UserDataService,
        private cookieService: CookieService
    ) {
        super();
    }

    ngOnInit(): void {
        this.hasBookAccessCode = this.userDataService.hasBookAccessCode();
        this.hasBookAccessCodePlus = this.userDataService.isPlusFeatureAccessible();
        this.hasBookAccessCodeNormal = this.userDataService.isNormalFeatureAccessible();
        this.setDismissText();
        this.isLoggedIn = this.applicationStateService.userData.loggedIn;

        this.physicalProductLink = this.applicationStateService.bookConfig.productLink;
        this.storeLink = this.applicationStateService.bookConfig.storeLink;
        this.coverImg = this.pageService.getPageByIndex(0).image.url;
        this.contactURL = this.routeService.getAbsoluteRoute(environment.endpointUrls.contactRoute, {});

        this.updateValues();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.updateValues();
    }

    getId(): string {
        return DisabledFeatureModalable.MODAL_ID;
    }

    updateValues(): void {
        this.setDismissText();
        this.type = this.modalService.getModalType(this.modalable);
        this.requiresPremiumPlus = this.modalService.checkPremiumPlus(this.modalable) && !this.hasBookAccessCodePlus;
        this.requiresPlus = this.modalService.checkNormal(this.modalable) && !this.hasBookAccessCodeNormal && !this.hasBookAccessCodePlus;

        this.cookieService.set('redirectIntention', encodeURI(window.location.href), 7, '/');
    }

    toggle($event): void {
        ($('#dropdownMenuButton') as any).dropdown('toggle');
    }

    onCodeSent($event): void {
        // console.log($event);
    }

    onInfoClicked(): void {
        ($('#collapseInfo') as any).collapse('toggle');
        setTimeout(() => {
            $('#featureDisabledModal').animate({
                scrollTop: 1000
            }, 1000);
        }, 10);
    }

    onChangeAccessCodeClicked(): void {
        this.modalService.closeModal(DisabledFeatureModalable.MODAL_ID);
        this.modalService.openModal(new ModalableAccessCode());
    }

    onCloseClicked(): void {
        this.modalService.closeModal(DisabledFeatureModalable.MODAL_ID);
    }

    userCanSkip(): boolean {
        const softAccess = this.quicklinkService.isAccessibleWithoutSoftAccess(this.type);
        if ((this.requiresPremiumPlus || this.requiresPlus) && !softAccess) {
            return false;
        }

        return softAccess;
    }

    /**
     * Determine if a special information for digi4school users should be displayed.
     * provideCode property should provide an access code to digi4school users automatically.
     * If no code or permission is present for this current digi4school user, display information how to enable it.
     */
    displayDigi4SchoolCodeInformation(): boolean {
        return this.applicationStateService.userData.digi4SchoolUser &&
            this.applicationStateService.bookConfig.provideCode;
    }

    // eslint-disable-next-line complexity
    onDismissClicked($event): void {
        this.modalService.closeModal(DisabledFeatureModalable.MODAL_ID);

        if (!(this.modalable instanceof QuickLink)) {
            return;
        }

        if (!this.quicklinkService.isAccessibleWithoutSoftAccess(this.type)) {
            return;
        }

        let iterator: IterableIterator<Array<QuickLink>>;
        switch (this.modalable.type) {
            case QuickLinkType.E_SQUIRREL:
                iterator = this.quicklinkService.quickLinks.eSquirrelQuickLinks.values();
                break;
            case QuickLinkType.HSM:
                iterator = this.quicklinkService.quickLinks.hsmQuickLinks.values();
                break;
            default:
                iterator = this.quicklinkService.quickLinks.genericQuickLinks.values();
        }

        // Disable "not accessible modal" after "continue" click
        for (const quicklinks of iterator) {
            quicklinks.forEach(quicklink => {
                quicklink.bypassCheck = quicklink.type === this.type && !this.modalService.checkPremiumPlus(this.modalable);
            });
        }

        this.modalable.bypassCheck = true;

        if (!this.modalable.isHSM()) {
            this.quicklinkService.openQuicklink(this.modalable);

            return;
        }

        const page = this.pageService.getPageById(this.modalable.pageId) ||
            this.pageService.getPageByIndex(this.applicationStateService.currentIndex);

        if (page && this.modalable.isHSM() && this.applicationStateService.bookConfig.bookPermissions.quickLinks.view) {
            this.homeworkService.openQuicklink(this.modalable, page.id, $event);

            return;
        }

        this.quicklinkService.openQuicklink(this.modalable);
    }

    private setDismissText(): void {

        this.dismissText = 'Buch ohne Sticker-Code verwenden';
        if (this.hasBookAccessCode && !this.isLoggedIn) {
            this.dismissText = 'Später anmelden';

            return;
        }
        if (this.modalable instanceof QuickLink &&
            this.applicationStateService.bookConfig.bookPermissions.quickLinks.view) {
            this.dismissText = 'Weiter ohne Sticker-Code';
        }

        if ((this.modalable instanceof QuickLink && this.modalable.type === ModalService.YEDO)) {
            this.dismissText = 'Yedo ohne Zugang öffnen';

            return;
        }

        if ((this.modalable instanceof QuickLink && this.modalable.type === ModalService.E_SQUIRREL)) {
            this.dismissText = 'eSquirrel ohne Zugang öffnen';

            return;
        }

        // Yedo button - no quicklink found on current pages.
        if (this.modalable instanceof ModalableYedo) {
            this.dismissText = 'Zurück zum Buch';
        }
    }

    protected versionTextPlaceholder(): string {
        if (this.requiresPlus) {
            return 'NORMAL';
        }

        return 'PLUS'
    }
}
